import { styled, Box, Typography } from '@mui/material';

import LoadingFallback from '~components/LoadingFallback';

export const DashboardVariantV2CarrierZoneSaturationCollapseTableContainer =
  styled(Box)(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden',
    position: 'relative',
  }));

export const DashboardVariantV2CarrierZoneSaturationCollapseTableLoading =
  styled(LoadingFallback)({
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    position: 'absolute',
    height: 'calc(100% - 43px)',
    zIndex: 4,
    width: '100%',
    inset: '43px 0 0',
  });

export const DashboardVariantV2CarrierZoneSaturationCollapseTableTitle = styled(
  Typography,
)(({ theme }) => ({
  display: 'block',
  padding: theme.spacing(1.5, 2),
  color: theme.palette.text.secondary,
  backgroundColor: theme.palette.action.hover,
}));
